import { ConfigMurucaResourceLayout } from '@net7/boilerplate-muruca';

export default {
  maxHeight: 100, // Threshold where the "read-more" button appears
  title: 'Traduzione',
  type: 'translation',
  bodyClasses: 'resource-accordion',
  sections: {
    top: [
      {
        id: 'header',
        type: 'title',
        grid: null,
      },
      {
        id: 'editor_metadata',
        type: 'metadata',
      },
    ],
    content: [
      {
        id: 'metadata',
        type: 'metadata',
      },
      {
        id: 'metadata-secondary-translations',
        type: 'metadata-dynamic',
        options: {
          accordion: true,
          dynamic: true
        }
      },
      {
        id: 'collection-primary-translation',
        type: 'collection',
        grid: 1,
        title: 'resource#collection_primary-translation',
        options: {
          linkTarget: '_blank',
        }
      },
      {
        id: 'collection-works',
        type: 'collection',
        grid: 1,
        title: 'resource#collection_works',
        options: {
          linkTarget: '_blank',
        }
      },
      {
        id: 'image-viewer-iiif',
        type: 'viewer-iiif',
        title: 'resource#image-viewer-iiif',
        options: {
          libOptions: {
            window: {
              sideBarOpenByDefault: false,
              allowClose: false,
              allowMaximize: true,
              defaultSideBarPanel: 'info',
              views: [
                { key: 'single' },
                { key: 'gallery' },
              ],
              workspaceControlPanel: {
                enabled: false,
              },
            },
            id: 'mirador-container',
          },
        }
      },
      {
        id: 'metadata-citazione',
        type: 'metadata',
        title: 'resource#metadata_citazione',
      },
    ],
  },
} as ConfigMurucaResourceLayout;
